import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin_petition_videos',
		path: '/admin/p/:slug/videos',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_petition_videos" */ './index'), {
			exportName: 'AdminPetitionVideos',
			fallback: Loading,
		}),
		frame: {
			header: true,
			footer: true,
		},
		restrictedAccess: {
			authOnly: true,
			role: ['staff', 'support'],
		},
		ssr: {
			// switch this to true to enable SSR
			enabled: false,
			seo: false,
		},
	},
];
